export default {
  REGISTER: 'REGISTER',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  PHONE_NUMBER_UPDATE: 'PHONE_NUMBER_UPDATE',
  CAMPAIGN: 'CAMPAIGN',
  EMAIL_UPDATE: 'EMAIL_UPDATE'
};
